"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validSigSchema = exports.validIbanSchema = exports.validAccountSchema = exports.validSignatureSchema = exports.sigSubmissionValidation = exports.ibanSubmissionValidation = exports.accountSubmissionValidation = exports.sigMissing = exports.invalidSig = exports.accountMissing = exports.accountCountryNotAccepted = exports.noSpacesAccount = exports.invalidIban = exports.invalidAccount = void 0;
const yup = __importStar(require("yup"));
const address_1 = require("./address");
exports.invalidAccount = "Invalid account";
exports.invalidIban = "Invalid IBAN";
exports.noSpacesAccount = "Please remove spaces from account number";
exports.accountCountryNotAccepted = "Unsupported country. See FAQ for list of accepted countries.";
exports.accountMissing = "Enter your account number...";
exports.invalidSig = "Invalid signature";
exports.sigMissing = "Enter a signature...";
// iban validation regex:
// Supported countries - All of Europe EXCEPT IBANs from the following countries:
// Albania, Andorra, Belarus, Bosnia and Herzegovina, Channel Islands,
// Faroe Islands, Gibraltar, Iceland, Ireland, Isle of Man, Malta,
// Moldova, Monaco, Montenegro, Russia, Serbia, Turkey, Ukraine
let noSpacesRegex = /^\S*$/;
// matches any general account (includes british accounts)
let generalAccountRegex = /\b[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}\b|(\d){8}/;
// matches any general IBAN (excludes british accounts)
let generalIbanRegex = /\b[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}\b/;
let supportedAccountCountriesRegex = /\b(?:(?:IT|SM)\d{2}[A-Z]\d{22}|(?:NL)\d{2}[A-Z]{4}\d{10}|(?:MK)\d{5}[A-Z0-9]{10}\d{2}|(?:CY|GR)\d{9}[A-Z0-9]{16}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|GB)\d{2}[A-Z]{4}\d{14}|RO\d{2}[A-Z]{4}\d{16}|NO\d{13}|(?:DK|FI|GL)\d{16}|(?:SI)\d{17}|(?:AT|EE|LU|XK|LT)\d{18}|(?:HR|LI|CH)\d{19}|(?:DE)\d{20}|(?:CZ|ES|SK|SE)\d{22}|PT\d{23}|(?:BE)\d{14}|(?:FR)\d{25}|(?:PL)\d{26}|(?:HU)\d{26})\b|(\d){8}/;
exports.accountSubmissionValidation = yup
    .string()
    .required(exports.accountMissing)
    .matches(noSpacesRegex, exports.noSpacesAccount)
    .matches(generalAccountRegex, exports.invalidAccount)
    .matches(supportedAccountCountriesRegex, exports.accountCountryNotAccepted);
exports.ibanSubmissionValidation = yup
    .string()
    .required(exports.accountMissing)
    .matches(noSpacesRegex, exports.noSpacesAccount)
    .matches(generalIbanRegex, exports.invalidIban)
    .matches(supportedAccountCountriesRegex, exports.accountCountryNotAccepted);
exports.sigSubmissionValidation = yup
    .string()
    .max(260, exports.invalidSig)
    .required(exports.sigMissing)
    .min(60, exports.invalidSig);
exports.validSignatureSchema = yup.object().shape({
    address: address_1.addressSubmissionValidation,
    account: exports.accountSubmissionValidation,
    sig: exports.sigSubmissionValidation,
});
exports.validAccountSchema = yup.object().shape({
    account: exports.accountSubmissionValidation,
});
exports.validIbanSchema = yup.object().shape({
    account: exports.ibanSubmissionValidation,
});
exports.validSigSchema = yup.object().shape({
    sig: exports.sigSubmissionValidation,
});
//# sourceMappingURL=sign.js.map